import { normalizeFilters } from '../redux/pushMessages/filters';

// What survives a reload (localStorage 'state', services/localStorage.js):
// the auth session and the shared audience-filter selection — always in
// its canonical 10-key shape, so a reload can never round-trip a partial
// object back into the store (the pre-2026-09 code saved a 7-key stub
// unless the selection had exactly 5 keys, which wiped the filters on
// every reload and screen switch).
export const pickPersistedState = (state) => {
  const auth = (state && state.authReducer) || {};
  const pushMessages = (state && state.pushMessagesReducer) || {};
  return {
    authReducer: {
      idToken: auth.idToken,
      expTimestamp: auth.expTimestamp,
      currentBloodbank: auth.currentBloodbank,
      bloodbankName: auth.bloodbankName,
      allBloodbanks: auth.allBloodbanks,
      userId: auth.userId,
      roleName: auth.roleName,
      imageRef: auth.imageRef,
      // feature flags survive a reload; refreshed again on session restore
      features: auth.features || {},
    },
    pushMessagesReducer: {
      selectedFilters: normalizeFilters(pushMessages.selectedFilters),
    },
  };
};

// createStore's preloadedState REPLACES a slice wholesale (no merge with the
// reducer's initialState). Only selectedFilters of the push-messages slice
// is persisted, so it is merged over the full initial shape — or every
// other key (message lists, messagesPaging) is undefined for the whole
// session.
export const mergePersistedState = (persistedState, pushMessagesInitialState) => {
  if (!persistedState) return persistedState;
  const persisted = persistedState.pushMessagesReducer;
  if (!persisted) return persistedState;
  return {
    ...persistedState,
    pushMessagesReducer: {
      ...pushMessagesInitialState,
      ...persisted,
      selectedFilters: normalizeFilters(persisted.selectedFilters),
    },
  };
};
